module.exports = __webpack_public_path__ + "assets/img/NPC043.a8034e57.png";